import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys, getPrefixKey } from "../../core/queries/queries-keys";

export const useSquidQueryClient = () => {
  const queryClient = useQueryClient();

  const invalidateQueries = (key: QueryKeys) => {
    const prefixKey = getPrefixKey(key);
    queryClient.invalidateQueries(prefixKey);
  };

  const refetchQueries = (key: QueryKeys) => {
    const prefixKey = getPrefixKey(key);
    queryClient.refetchQueries(prefixKey);
  };

  const invalidateAndRefetchQueries = (key: QueryKeys) => {
    invalidateQueries(key);
    refetchQueries(key);
  };

  return {
    invalidateQueries,
    refetchQueries,
    invalidateAndRefetchQueries,
  };
};
